import { Reducer } from 'redux';
import { BorrowerActionTypes } from '../constants/actionTypes';
import {
  IBorrowerProfileData,
  IBorrowerProfileDataAction,
} from '../actions/borrowerProfileAction';

export type BorrowerActions = IBorrowerProfileDataAction;

export interface IBorrowerProfileState {
  readonly borrowerProfileStateData: IBorrowerProfileData | undefined;
}

// Define the initial state
const initialState: IBorrowerProfileState = {
  borrowerProfileStateData: undefined,
};

export interface IBorrowerProfileStateData {
  borrowerProfileState: {
    borrowerProfileStateData: IBorrowerProfileData | undefined;
  };
}

export const borrowerReducer:
  // eslint-disable-next-line max-len
  Reducer<IBorrowerProfileState, BorrowerActions> = (state = initialState, action: BorrowerActions) => {
    switch (action.type) {
      case BorrowerActionTypes.FETCH_BORROWER_PROFILE_DATA:
        return {
          ...state,
          borrowerProfileStateData: action.borrowerProfileData,
        };
      default:
        return state;
    }
  };
